export default {
  name: "Transactions",
  path: "/transactions",
  component: () => import("@/views/Transactions"),
  props: true
};
